export const getConfigObject = () => {
  return window.config || {};
};

export const setConfigFeatures = (config) => {
  if (typeof window === 'undefined') return;

  const { features, ...rest } = config;
  window.config = {
    ...window.config,
    features: {
      ...window.config.features,
      ...features,
    },
    ...rest,
  };
  // Setup client-side instana
  if (window.config.instanaKey) {
    /* eslint-disable no-unused-expressions */
    (function (c, e, f, k, g, h, b, a, d) {
      c[g] ||
        ((c[g] = h),
        (b = c[h] = function () {
          b.q.push(arguments);
        }),
        (b.q = []),
        (b.l = 1 * new Date()),
        (a = e.createElement(f)),
        (a.async = 1),
        (a.src = k),
        a.setAttribute('crossorigin', 'anonymous'),
        (d = e.getElementsByTagName(f)[0]),
        d.parentNode.insertBefore(a, d));
    })(
      window,
      document,
      'script',
      '//eum.instana.io/eum.min.js',
      'InstanaEumObject',
      'ineum'
    );
    /* eslint-disable no-undef */
    ineum('reportingUrl', 'https://eum-us-west-2.instana.io');
    ineum('key', window.config.instanaKey);
  }
};
